import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'escandallos',
})
export class EscandallosPipe implements PipeTransform {

  transform(items: any[], filter: any[]): any {

    if (items) {

      if (filter['id_familia_top'] && filter['id_familia_top'] > 0) {

        items = items.filter((item) => item.id_familia_pricipal == filter['id_familia_top']);
      }

      if (filter['id_familia'] && filter['id_familia'] > 0) {

        items = items.filter((item) => item.id_familia == filter['id_familia']);
      }

      if (filter['id_local'] && filter['id_local'] > 0) {

        items = items.filter((item) => item.locales.includes(parseInt(filter['id_local'])));
      }

      if (filter['id_departamento'] && filter['id_departamento'] > 0) {

        items = items.filter((item) => item.departamentos.includes(parseInt(filter['id_departamento'])));
      }

      if (filter['id_partida'] && filter['id_partida'] > 0) {

        items = items.filter((item) => item.partidas.includes(parseInt(filter['id_partida'])));
      }

    }

    return items;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/escandallos/escandallos.ts